import { FC } from 'react';
import { Badge } from 'antd';
import { BadgeProps } from 'antd/lib/badge';

export const ILSBadgeRibbon: FC<BadgeProps> = (props) => {
  return <Badge.Ribbon {...props} />;
};

